import { render, staticRenderFns } from "./QueenEdit.vue?vue&type=template&id=7454a0ea&scoped=true&"
import script from "./QueenEdit.vue?vue&type=script&lang=js&"
export * from "./QueenEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7454a0ea",
  null
  
)

export default component.exports